module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/space-1-medium-4ade6e55b9ba0f18a828319ab9981e26.jpg";